<template>
    <div class="card mb-25 border-0 rounded-0 bg-white add-user-card">
     <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing">
             <Form ref="elementForm" @submit="addElement" :validation-schema="venteSchema">
               
                <div class="tab-pane fade show active p-10" id="home-tab-pane" role="tabpanel" tabindex="0">
                    <div class="row">

                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                                Date
                            </label>
                            <Field name="dateVente" type="date"  :value="getCurrentDate()"
                            class="form-control shadow-none fs-md-15 text-black"/>
                            <ErrorMessage name="dateVente" class="text-danger"/>
                            </div>
                        </div>
    
                        <div class="col-md-6">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                    Client <span class="text-danger">*</span>
                                </label>
                                <Field name="client" v-slot="{ field }">
                                    <Multiselect
                                    :options="clientOptions"
                                    :searchable="true"
                                    track-by="label"
                                    label="label"
                                    v-model = "field.value"
                                    v-bind = "field"
                                    placeholder="Sélectionnez le client"
                                    />
                                </Field>
                                <ErrorMessage name="client" class="text-danger"/>
                            </div>
                        </div>

                        <div class="col-md-12">
                            <div class="card" style="padding:0px !important;">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <h5 class="card-title mb-0">Liste des produits à vendre</h5>
                                    <!-- <button 
                                        type="button"
                                        class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                                        @click="addProduit"
                                    >
                                        + produit
                                    </button> -->
                                </div>
                                <div class="card-body">
                                    <div class="table" style="width: 100% !important;">
                                        <thead style="width: 100% !important;">
                                            <th style="min-width: 300px !important;">Produit</th>
                                            <th>Qté</th>
                                            <th>Prix</th>
                                            <th>Montant</th>
                                            <th> Stock </th>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(pc, index) in produitConds" :key="index">
                                                <!-- <MyProduitConditionnement 
                                                    :options="produitOptions" 
                                                    :index="index" 
                                                    :conditionnementData="produit"
                                                    @update-field="updateFields"
                                                    @remove-produit="removeProduit"
                                                    @update-total="updateTotal"
                                                /> -->
                                                <td style="margin-bottom: 5px !important;">
                                                    <Field :name="'pcv_'+index" v-model="pc.produitConditionnement"  v-slot="{ field }" style="min-width: 50px !important;">
                                                        <Multiselect
                                                            v-model = "field.value"
                                                            v-bind = "field"
                                                            :options="getFilteredOptions(index)"
                                                            :searchable="true"
                                                            placeholder="Rechercher"
                                                            noResultText= "Aucun enregistrement trouvé"
                                                            noOptionsText="Tapez au moins deux caractères" />
                                                    </Field>
                                                    <ErrorMessage :name="'pcv_'+index" class="text-danger"/>
                                                </td>


                                                <td> 
                                                    <!-- {{ pc.qteVendu }} -->
                                                    <Field :name="'pcv_qteVendu'+index" 
                                                    type="text" 
                                                    v-model="pc.qteVendu"
                                                    @input="validateQuantity(index)"
                                                    class="form-control shadow-none fs-md-15 text-black" 
                                                    placeholder="0"/>
                                                    <ErrorMessage :name="'pcv_qteVendu'+index" class="text-danger"/>
                                                </td>


                                                <td>
                                                    <Field :name="'pcv_prix'+index" type="number" 
                                                    v-model="pc.prix"
                                                    @input="validatePrice($event, index)"
                                                    class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                                                    <ErrorMessage :name="'pcv_prix'+index" class="text-danger"/>
                                                </td>


                                                <td>
                                                    <Field :name="'pcv_montant'+index" type="text" v-model="pc.montant"
                                                    class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                                                    <ErrorMessage :name="'pcv_montant'+index" class="text-danger"/>
                                                </td>
                                                <td>
                                                    <span class="badge text-outline-danger fs-7">{{ pc.qteStock }}</span>
                                                </td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        class="btn btn-sm btn-outline-danger"
                                                        @click="removeLigne(index)"
                                                    >
                                                        x
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </div>
                                </div>
                                <div class="card-footer">
                                    <button 
                                        type="button"
                                        class="default-btn transition border-0 fw-medium text-white pt-6 pb-6 ps-25 pe-25 pt-md-5 pb-md-5 ps-md-20 pe-md-20 rounded-1 fs-md-15 fs-lg-16"
                                        @click="addProduit"
                                    >
                                        + produit
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div style="clear:both;"></div><br>

                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Epargne <span class="text-danger">*</span>
                                </label>
                                <Field name="epargne" type="text" v-model="montantEpargne"
                                class="form-control shadow-none fs-md-15 text-black" placeholder="0"/>
                                <ErrorMessage name="epargne" class="text-danger"/>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Mise <span class="text-danger">*</span>
                                </label>
                                <Field name="mise" type="text" v-model="montantMise" 
                                class="form-control shadow-none fs-md-15 text-black" readonly placeholder="0"/>
                                <ErrorMessage name="mise" class="text-danger"/>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Montant / 20 <span class="text-danger">*</span>
                                </label>
                                <Field name="mt20" type="text" v-model="mt20"
                                class="form-control shadow-none fs-md-15 text-black" readonly placeholder="0"/>
                                <ErrorMessage name="mt20" class="text-danger"/>
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group mb-15 mb-sm-20 mb-md-25">
                                <label class="d-block text-black fw-semibold mb-10">
                                Montant total <span class="text-danger">*</span> ( {{ total }} )
                                </label>
                                <Field name="montant" type="text" v-model="montantTotal"
                                class="form-control shadow-none fs-md-15 text-black" readonly placeholder="0"/>
                                <ErrorMessage name="montant" class="text-danger"/>
                            </div>
                        </div>

                    </div>
                </div>
                
                <div class="row">
                    <div class="col-md-12">
                        <div class="d-flex align-items-center ">
                            <button
                                class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
                                type="submit"
                                :disabled="isSubmitting"
                            >
                                <span v-if="isSubmitting" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                <span v-else>Enregistrer</span>
                            </button>
                            <router-link to="/ventes" 
                                class=" btn btn-danger transition border-0 lh-1 fw-medium"><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
                                <span class="position-relative"></span>Annuler
                            </router-link>
                        </div>
                    </div>
                </div>
            </Form>
     </div>
    </div>
   
   
   </template>
   
   <script lang="ts">
   import { defineComponent, onMounted, reactive, ref, watch } from "vue";
   import { Form, Field, ErrorMessage } from "vee-validate";
   import { error, success, showModal, hideModal, openNewWindow } from "../../utils/utils";
   import { useRoute, useRouter } from "vue-router";
   import ApiService from "../../services/ApiService";
   import { Vente } from "../../models/Vente";
   import { ProdCondVente } from "../../models/ProdCondVente";
   import * as Yup from "yup";
   import Multiselect from '@vueform/multiselect';
   import Swal from "sweetalert2";
   
   export default defineComponent({
     name: "AddVente",
     components: {
       Form,
       Field,
       ErrorMessage,
       Multiselect
     },
     
     setup: (props, { emit }) => {
       const venteSchema = Yup.object().shape({
         client: Yup.string().required("Le client est obligatoire"),
         montant: Yup.string().required("Le montant total est obligatoire"),
         epargne: Yup.string().required("L'epargne est obligatoire"),
       });
   
        const venteForm = ref<Vente | null>(null);
        const router = useRouter();
        const isSubmitting = ref(false);
   
        const contenuEditor = ref();
        const metaDescriptionEditor = ref();
        const empty = ref("<p><br></p>")
        const produitOptions = ref([]);
        const clientOptions = ref([]);
        const isUPDATE = ref(false);
        const btntext = ref("Ajouter");
        const title = ref("Ajouter un article");
        // const produits = ref<any[]>([]);
        const produitsave = ref<any[]>([]);
        const montantTotal = ref(0);
        const montantEpargne = ref(0);
        const montantMise = ref(0);
        const total = ref(0);
        const mt20 = ref(0);
   
    //    watch(title, (newValue) => {
    //      console.log('title', title.value)
    //      console.log('generateSlug', alias.value)
    //      console.log('after', alias.value)
    //    })

        const produitConds = reactive([{
            produitConditionnement: null,
            qteVendu: 0,
            prix: 0,
            prixMin: 0,
            prixMax: 0,
            montant: 0,
            nomComplet: "",
            qteStock: 0
        }]);


        const btnTitle = async () => {
            if (isUPDATE.value) {
            title.value = "Modifier le client";
            btntext.value = "Modifier";
            }else{
            title.value = "Ajouter un client";
            btntext.value = "Ajouter";
            }
        }

        // const updateFields = ({ index, data }) => {
        //     produits.value[index] = data;
        // };

        const removeLigne = (index) => {
            produitConds.splice(index, 1);
        };

        const addProduit = () => {
            produitConds.push({
                produitConditionnement: null,
                qteVendu: 0,
                prix: 0,
                prixMin: 0,
                prixMax: 0,
                montant: 0,
                nomComplet: "",
                qteStock: 0
            });
        };

        const updateTotal = () => {
            total.value = produitConds.reduce((acc, p) => {
                return acc + p.montant;
            }, 0);
            // montant sur 20
            mt20.value = total.value / 20;
            // montant epargne
            let digit: string = (total.value/20).toString().slice(-2);
            if (parseInt(digit) <= 100) {
                montantEpargne.value = (100 - parseInt(digit)) + 100;
            }
            //montant mise
            montantMise.value = montantEpargne.value + mt20.value;
            // montant total
            montantTotal.value = total.value + ( montantEpargne.value * 20);

        };

        watch(() => montantEpargne.value , (newValue) => {
            // console.log("deschanel");
            montantMise.value = parseFloat(newValue.toString()) + parseFloat(mt20.value.toString());
            montantTotal.value = total.value + ( newValue * 20);
        });

        // const epargneChange = () => {
        //     console.log("nous sommes ici",montantEpargne.value, mt20.value);
        //     montantMise.value = montantEpargne.value + (mt20.value);
        //     montantTotal.value = total.value + ( montantEpargne.value * 20);
        // }

        const removeProduit = (index) => {
            produitConds.splice(index, 1);
        };

        watch(() => produitConds.map((pc, index) => ({produitConditionnement: pc.produitConditionnement, index})), (newValue) => {
            newValue.forEach(({ produitConditionnement, index }) => {
                if(produitConds[index].produitConditionnement){
                    let pri : any =  produitConds[index].produitConditionnement;
                    let prix =  pri.split("-")[1]
                    produitConds[index].qteVendu = (newValue && produitConds[index].qteVendu > 1) ? produitConds[index].qteVendu : 1;
                    produitConds[index].prix = (prix && produitConds[index].prix != prix) ? prix : produitConds[index].prix;
                    produitConds[index].prixMin = pri.split("-")[2];
                    produitConds[index].prixMax = pri.split("-")[3];
                    produitConds[index].montant = (produitConds[index].prix) ? produitConds[index].prix * produitConds[index].qteVendu : 0;
                    produitConds[index].qteStock = pri.split("-")[4];
                    
                }
            });
            updateTotal();
        });

        watch(() => produitConds.map((pc, index) => ({qteVendu: pc.qteVendu, index})), (newValue) => {
            newValue.forEach(({ qteVendu, index }) => {
                if( parseFloat(qteVendu.toString()) > parseFloat(produitConds[index].qteStock.toString())) {
                    console.log("qteVendu", qteVendu);
                    produitConds[index].qteVendu = produitConds[index].qteStock;
                }else{
                    produitConds[index].montant = (produitConds[index].prix) ? produitConds[index].prix * produitConds[index].qteVendu : 0;
                }
                // const prix =  produitConds[index].prix;
                // produitConds[index].qteVendu = (newValue && produitConds[index].qteVendu > 1) ? produitConds[index].qteVendu : 1;
                // produitConds[index].prix = (prix && produitConds[index].prix != prix) ? prix : produitConds[index].prix;
                // produitConds[index].montant = (produitConds[index].prix) ? produitConds[index].prix * produitConds[index].qteVendu : 0;
            });
            updateTotal();
        });

        const validateQuantity = (index) => {
            
            // if (produitConds[index].qteVendu < 1 && produitConds[index].qteVendu > produitConds[index].qteStock) {
            //     console.log("validate Quantity", produitConds[index].qteVendu);
            //     produitConds[index].qteVendu = 1; // Réinitialiser à 1 si la valeur est inférieure
            // }
        };

        // watch(() => produitConds.map((pc, index) => ({prix: pc.prix, index})), (newValue) => {
        //     newValue.forEach(({ prix, index }) => {
        //         produitConds[index].montant = (produitConds[index].prix) ? prix * produitConds[index].qteVendu : 0;
        //         // Controlle d'intervalle de prix
        //         // if(prix < produitConds[index].prixMin){
        //         //     produitConds[index].prix = produitConds[index].prixMin;
        //         // }
        //         // if(prix > produitConds[index].prixMax){
        //         //     produitConds[index].prix = produitConds[index].prixMax;
        //         // }
        //     });
        //     updateTotal();
        // });

        // Validation de prix
        const validatePrice = (event, index) => {
            const prix = parseFloat(event.target.value);
            produitConds[index].prix = prix;
            console.log("prix", prix);
            if(prix < produitConds[index].prixMin){
                produitConds[index].prix = produitConds[index].prixMin;
                console.log("prix min", produitConds[index].prixMin);
            }else if(prix > produitConds[index].prixMax){
                produitConds[index].prix = produitConds[index].prixMax;
                console.log("prix max", produitConds[index].prixMax);
            }else{
                produitConds[index].prix = prix;
                console.log("prix ok", prix);
            }
            console.log("prodConds", produitConds);
            updateTotal();
        };
         
   
        onMounted(()=> {
            fetchClient()
            fetchProduit()
        })
   
        const getCurrentDate = () => {
             const today = new Date();
             const day = String(today.getDate()).padStart(2, '0');
             const month = String(today.getMonth() + 1).padStart(2, '0');
             const year = today.getFullYear();
             return `${year}-${month}-${day}`;
        }

        const getFilteredOptions = (index) => {
            const selectedOptions = produitConds.map(c => c.produitConditionnement);
            return produitOptions.value.filter((option: any) => {
                return !selectedOptions.includes(option.value) || option.value === produitConds[index].produitConditionnement;
            });
        };
   
        const fetchClient = async () => {
            try {
                // const response = await ApiService.get('/clients?limit=-1&');
                const response = await ApiService.get('/clientsSansDettes?limit=-1&');
                console.log('client',response);
                const data = response.data.data.data;
                clientOptions.value = data.map((client) => ({
                    value: client.id,
                    label: '['+ client.code +'] '+client.nom+' '+client.prenoms,
                }));
            } catch (error) {
                //
                console.log('error',error);
            }
        };

        const fetchProduit = async () => {
            ApiService.get("/produitConditionnements?limit=-1&")
            .then(({ data }) => {
                
            produitOptions.value = data.data.data
            // .filter(p => p.qteStock > 0)
            .map((p) => {
                return { 
                    value: p.id+'-'+p.prix+'-'+p.prixMin+'-'+p.prixMax+'-'+p.qteStock,
                    label: p.nomComplet +' [ '+ p.conditionnement.code +' ]',
                    disabled: p.qteStock <= 0
                }
            });
            console.log("propro",produitOptions.value);
            })
            .catch(({ response }) => {
            // produitsError.value = true;
            });
        };
   
       const showA = ref(false)
       const show = ref("0")
   
       const addElement = async (values: any, elementForm) => {
            isSubmitting.value = true;

            // Supprimer dynamiquement tous les champs liés aux conditionnements
            Object.keys(values).forEach(key => {
                if (key.startsWith('pcv_')) {
                    delete values[key];
                }
            });

            produitsave.value = produitConds.map((pro) => {
                const p = { ...pro }; 
                // if (p.produitConditionnement && typeof p.produitConditionnement === 'string') {
                //     const parts = p.produitConditionnement.split('-');
                //     if (parts.length > 1) {
                //         p.produitConditionnement = parts[0];
                //     }
                // }
                return p;
            });
            console.log("Produits après modification:", produitConds);
            console.log("Produits après modification:", produitsave.value);
            console.log("value", values);


            // ici produit n'est rien d'aute que produit conditionnement vente
            values.prodCondVentes = produitsave.value;
            const now = new Date();
            const currentTime = `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}:${String(now.getSeconds()).padStart(2, '0')}`;
            values.dateVente = values.dateVente + " " + currentTime;
            values = values as Vente;

            if(isUPDATE.value){
                ApiService.put("/vente/"+values.id,values)
                .then(({ data }) => {
                    if(data.code == 200) { 
                        success(data.message);
                        elementForm.resetForm();
                        isUPDATE.value=false;
                        btnTitle();
                    }
                })
                .catch(({ response }) => {
                    error(response.data.message);
                });
            }else{
                values.montantSansEpargne = total.value;
                console.log("form", values);
                ApiService.post("/vente",values)
                .then(({ data }) => {
                    if(data.code == 201) { 
                        success(data.message);
                        const maFonction = async () => {
                        const result = await Swal.fire({
                            html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                            icon: "success",
                            buttonsStyling: true,
                            confirmButtonText: "Aperçu",
                            showCancelButton: false,
                            cancelButtonText: `Fermer`,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            heightAuto: false,
                            customClass: {
                            confirmButton: "btn btn-success",
                            cancelButton: "btn btn-warning",
                            },
                        });

                        if (result.isConfirmed) {
                            console.log('ok ok', data.data);
                            openNewWindow(data.data.fileName, "Engagement");
                            router.push('/ventes');
                        }
                        };
                        setTimeout(maFonction, 300);
                        // router.push('/ventes');
                        // elementForm.resetForm();
                    }
                })
                .catch(({ response }) => {
                    error(response.data.message);
                    router.push('/ventes');
                });
            }
       };
   
   
       return { 
            addElement,
            venteSchema,
            clientOptions,
            produitOptions,
            getCurrentDate,
            btnTitle,
            addProduit,
            removeProduit,
            updateTotal,
            montantTotal,
            mt20,
            montantEpargne,
            montantMise,
            total,
            removeLigne,
            produitConds,
            getFilteredOptions,
            validatePrice, // validation d'interval de prix
            isSubmitting,
            validateQuantity
            
       };
     },
   });
   </script>
   
   <style scoped>
     table tbody td {
       padding-left: 0px !important;
     }
     .table > :not(caption) > * > * {
        padding-left: 0px !important;
     }
   </style>
   
   